import { createSlice } from '@reduxjs/toolkit';
import { createDropdownSettingApi } from '../../../rtk-apis/clinics/createDropdownSetting';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const createDropdownSettingSlice = createSlice({
  name: 'createDropdownSetting',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(createDropdownSettingApi.pending, state => {
        state.loading = true;
      })
      .addCase(createDropdownSettingApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(createDropdownSettingApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default createDropdownSettingSlice.reducer;
export const { clearState } = createDropdownSettingSlice.actions;
